import React from 'react';
import { BaseLayoutFactory } from '../global/base-layout-factory';
import SiteMapComponent from './site-map-component';

const SiteMapFactory: React.FC = () => {
  return (
    <BaseLayoutFactory>
      <SiteMapComponent />
    </BaseLayoutFactory>
  );
};

export default SiteMapFactory;
